import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', fontFamily: "'Georgia', serif", background: '#f8f5fc',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>404</div>
        <h1 style={{ color: '#2d1b4e', fontSize: 24, margin: '0 0 8px' }}>Page Not Found</h1>
        <p style={{ color: '#7a6a8a', marginBottom: 24 }}>The page you're looking for doesn't exist.</p>
        <Link to="/" style={{
          padding: '12px 32px', borderRadius: 20, background: 'linear-gradient(135deg, #7c4dba, #9b72cf)',
          color: '#fff', textDecoration: 'none', fontWeight: 600,
        }}>
          Go Home
        </Link>
      </div>
    </div>
  )
}
